import { NetworkConfig } from '../signing/types';
import { getConfig } from './networkConfigStore';

export type ExplorerEntity = 'account' | 'transaction' | 'token' | 'schedule';

const HASHSCAN_BASE = 'https://hashscan.io';

export function buildExplorerUrl(
  network: string,
  entity: ExplorerEntity,
  id: string,
  config?: NetworkConfig | null,
): string | null {
  // Public networks — use hashscan.io
  if (network === 'testnet' || network === 'mainnet' || network === 'previewnet') {
    return `${HASHSCAN_BASE}/${network}/${entity}/${id}`;
  }

  // Custom network with explorer configured
  if (config?.explorer) {
    return `${config.explorer.replace(/\/+$/, '')}/${entity}/${id}`;
  }

  // Custom network without explorer
  return null;
}

/**
 * Convenience wrapper that auto-resolves the network config from localStorage.
 * For public networks, returns hashscan.io URLs.
 * For custom networks, reads the explorer URL from the stored config.
 */
export function getExplorerUrl(
  network: string,
  entity: ExplorerEntity,
  id: string,
): string | null {
  const config = network?.startsWith('custom-') ? getConfig(network) : null;
  return buildExplorerUrl(network, entity, id, config);
}
